import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Services from '../views/ServicesPage.vue'
import Careers from '../views/Careers.vue'
import ErrorPage from '../views/ErrorPage.vue'
import KurdosLayout from '../layouts/KurdosHealthcare.vue'
import Wellness from '../views/healthcare/Wellness.vue'
import MedTech from '../views/healthcare/MedTech.vue'
import Infrastructure from '../views/healthcare/Infrastructure.vue'
import WhoWeAre from '../views/healthcare/WhoWeAre.vue'
import Landing from '../views/healthcare/LandingPage.vue'
import Contact from '../views/Contact.vue'
import HealthcareContact from '../views/healthcare/Contact.vue'
import LandingSelector from '../views/common/LandingSelector.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: LandingSelector
  },
  {
    path: '/logistics',
    name: 'Home',
    component: Home
  },
  {
    path: '/logistics/about',
    name: 'About',
    component: About,
  },
  {
    path: '/logistics/services',
    name: 'Services',
    component: Services,
  },
  {
    path: '/logistics/careers',
    name: 'Careers',
    component: Careers,
  },
  {
    path: '/logistics/contact',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/healthcare',
    name: 'healthcare',
    redirect: '/healthcare/',
    component: KurdosLayout,
    meta: {
      title: "Kurdos Healthcare"
    },
    children: [
      {
        path: '',
        name: 'home',
        component: Landing
      },
      {
        path: 'wellness',
        name: 'wellness',
        component: Wellness
      },
      {
        path: 'medtech',
        name: 'medtech',
        component: MedTech
      },
      {
        path: 'infrastructure',
        name: 'infrastructure',
        component: Infrastructure
      },
      {
        path: 'who-we-are',
        name: 'whoweare',
        component: WhoWeAre
      },
      {
        path: 'contact-us',
        name: 'contact',
        component: HealthcareContact
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: ErrorPage
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {

    return { top: 0 }

  }
})


router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router